<template>
  <div>
    <Card>

      <Form ref="formValidate"  :label-width="100">
      <FormItem label="背景图片" prop="backurl" >
      <el-upload
        action="/api/v1/stall/uploadfile/"
        list-type="picture-card"
        :data="{mid:14}"
        :file-list = "filelist"
        :auto-upload="true">
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
          <img
            class="el-upload-list__item-thumbnail"
            :src="file.url" alt=""
          >
      <span class="el-upload-list__item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>

      </span>
    </div>
</el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </FormItem>
      </Form>
      <tables ref="tables" editable search-place="top" v-model="tableData" :columns="columns"
       @on-save-edit="handleInput">
      </tables>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: left;">
            <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[10,15,25,35,50,100] show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize"></Page>
        </div>
    </div>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import FormGroup from '_c/form-group'
import { mapState } from 'vuex'
import { getstallinfo, updatestall } from '@/api/stall'
export default {
  components: {
    Tables,
    FormGroup
  },
  data () {
    return {
      // 弹出框
      modalMap: {
        modalVisible: false,
        modalTitle: '创建用户'
      },
      columns: [
        { title: '摊位号', key: 'num', sortable: true },
        { title: '内容', key: 'title', editable: true },
        { title: '备注', key: 'remark', editable: true },
        { title: '所属市场', key: 'marker', sortable: true },
        { title: '字体大小', key: 'size', editable: true },
        {
          title: '颜色',
          key: 'colour',
          align: 'center',
          render: (h, params, vm) => {
            return h('div', [
              h('el-color-picker', {
                props: {
                  value: params.row.colour
                },
                on: {
                  'active-change': (e) => {
                    this.colourchange(params, e)
                  }
                }
              })
            ])
          }
        },

        {
          title: '字体',
          key: 'font',
          align: 'center',
          render: (h, params, vm) => {
            return h('div', [
              h('el-select', { props: {
                  placeholder: '请选择',
                value: params.row.font },
on: {
                  'change': (e) => {
                    this.fontchange(params, e)
                  }
                } }, [
                h('el-option', {
                props: {
                  key: '黑体',
                  value: '黑体',
                  label: '黑体'
                }
                }),
                h('el-option', {
                props: {
                  key: '微软雅黑',
                  value: '微软雅黑',
                  label: '微软雅黑'
                }
                }),
                h('el-option', {
                props: {
                  key: '仿宋',
                  value: '仿宋',
                  label: '仿宋'
                }
                }), h('el-option', {
                props: {
                  key: '楷体',
                  value: '楷体',
                  label: '楷体'
                }
                })
              ])])
}
        },
        {
          title: '状态',
          key: 'state',
          align: 'center',
          render: (h, params, vm) => {
            return h('div', [
              h('i-switch', {
                props: {
                  // type: "primary",
                  value: params.row.state === 1 // 控制开关的打开或关闭状态，官网文档属性是value
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  'on-change': (e) => {
                    this.onSwitch(params, e)
                  }
                }
              })
            ])
          }
        }

      ],
      // 搜索数据
      searchKey: '',
      searchValue: '',
      // 分页数据
      tableData: [],
      pageTotal: 0, // 数据总数
      pageNum: 1, // 当前页码
      pageSize: 15, // 每页条数
      // select
      selectionList: [],
      backurl: '',
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      filelist: []
    }
  },
  computed: {
    ...mapState({
      rules: state => state.user.rules
    })
  },
  methods: {

      handlePictureCardPreview (file) {
        this.filelist.forEach(item => { console.log(item.url) })
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
    handleRemove (file, fileList) {
        console.log(file, fileList)
      },

    changePage (value) {
      this.pageNum = value
      this.getUserList(
        this.pageNum,
        this.pageSize,
        this.searchKey,
        this.searchValue
      )
    },
    // 每页条数
    handlePageSize (value) {
      this.pageSize = value
      this.getUserList(1, this.pageSize, this.searchKey, this.searchValue)
    },

    // 获取用户列表
    getstallinfo (page, limit, key, value) {
      getstallinfo(page, limit, key, value).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(`${res.data.msg}`)
          this.pageTotal = res.data.count
          this.tableData = res.data.data
          if (res.data.backurl) {
            this.backurl = res.data.backurl
          }
          // this.backurl = 'http://gips3.baidu.com/it/u=3886271102,3123389489&fm=3028&app=3028&f=JPEG&fmt=auto?w=1280&h=960'
          this.filelist = [{ name: 'text', url: this.backurl }]
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        console.log(this.backurl)
      })
    },

    handleInput (editData) {
      // 行内编辑
      const EditData = {
        id: editData.row.id,
        key: editData.column.key,
        value: editData.value
      }
      updatestall(EditData).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(`${res.data.msg}`)
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },

    rgbToHex (rgb) {
      // 移除 'rgb(' 和 ')' 并分割字符串
      const rgbArray = rgb.replace(/^rgb\(/, '').replace(/\)$/, '').split(',')

      // 将每个颜色值转换为十六进制并拼接
      const hex = rgbArray.map(num => {
        const hexNum = Number(num).toString(16)
        return hexNum.length === 1 ? '0' + hexNum : hexNum
      }).join('')

      // 返回带有 '#' 前缀的十六进制颜色
      return '#' + hex
    },
    colourchange (editData, e) {
        const hex = this.rgbToHex(e)
      const EditData = {
        id: editData.row.id,
        key: editData.column.key,
        value: hex
      }
      updatestall(EditData).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(`${res.data.msg}`)
          this.tableData[editData.index].colour = hex
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
        fontchange (editData, e) {
      const EditData = {
        id: editData.row.id,
        key: editData.column.key,
        value: e
      }
      updatestall(EditData).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(`${res.data.msg}`)
          this.tableData[editData.index].font = e
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    // 弹出对话框
    showModal () {
      this.modalMap.modalVisible = true
    },
    // 调用开关
    onSwitch (editData, e) {
      let value = '0'
      if (e) {
        value = '1'
      }
      console.log(value)
      const EditData = {
        id: editData.row.id,
        key: editData.column.key,
        value: value
      }
      updatestall(EditData).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(`${res.data.msg}`)
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    }

  },
  mounted () {
    this.getstallinfo(this.pageNum, this.pageSize)
  }
}
</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 350px;
    }
    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
<style lang="scss">
 // 隐藏清空按钮
   .el-color-dropdown__link-btn-qingkong {
        display: none;
    }
</style>
